"use strict";

angular.module('rmRole')

.config(['$stateProvider',function ($stateProvider) {

    $stateProvider
        .state('role', {
            url: "/role",

            views: {

                'roleoverview': { 

                    templateUrl: '/partial/app.partials.role.overview',
                    controller: 'RoleOverviewCtrl',
                    controllerAs: 'roleCtrl'
                },
                'roledetail': { 
                 
                    templateUrl: '/partial/app.panels.empty'
                }
            },

            onEnter: ['bladesManager', function( bladesManager ) {

                bladesManager.clearAll();
                bladesManager.insert({ viewName:'roleoverview', size:'half' });
                bladesManager.insert({ viewName:'roledetail', size:'half' });                  
            }],
        })
        .state('role.create', {
            url: "/create", 
            views: {
                
                'roledetail@': { 

                    templateUrl: '/partial/app.partials.role.detail',
                    controller: 'RoleFormCtrl',
                    controllerAs: 'ctrl'
                }
            }
        }).state('role.update', {
            url: "/update/:id", 
            views: {
                
                'roledetail@': { 

                    templateUrl: '/partial/app.partials.role.detail',
                    controller: 'RoleFormCtrl',
                    controllerAs: 'ctrl'
                }
            }
        });
}]);


/*


"use strict";

var app = angular.module('rmRole');

app.config(function ($stateProvider) {

	$stateProvider
		.state('role', {
			url: "/role",
			templateUrl: '/partial/app.partials.role.overview',
			controller: 'RoleOverviewCtrl',
			controllerAs: 'roleCtrl'
		})
		.state('role.create', {
			url: "/create",
			views: {
				detail: {
					templateUrl: '/partial/app.partials.role.detail',
					controller: 'RoleFormCtrl',
					controllerAs: 'ctrl'
				}
			}
		})
		.state('role.update', {
			url: "/update/:id",
			views: {
				detail: {
					templateUrl: '/partial/app.partials.role.detail',
					controller: 'RoleFormCtrl',
					controllerAs: 'ctrl'
				}
			}
		});
});
*/